var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "100px",
    viewBox: "0 0 102 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C763F00F-4557-4703-860A-B551E5E436E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NL-Home---Unlock-wallet",
    transform: "translate(-449.000000, -228.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "block-2",
    transform: "translate(360.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(60.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/icon/metamask",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "metamask-fox.c06f3a3e",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#E17726",
    fill: "#E17726",
    points: "93.9947059 0 55.365 28.5832353 62.5485294 11.7382059"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#E27625",
    stroke: "#E27625"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.89105882 0 43.1767647 28.85 36.3373529 11.7381765"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "80.0867647 66.275 69.8082353 81.9767647 91.8167647 88.0364706 98.1214706 66.6179412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.802382353 66.6179412 7.06870588 88.0364706 29.0391176 81.9767647 18.7989412 66.275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "27.8547059 39.7497059 21.7411765 48.9726471 43.5205882 49.9635294 42.7944118 26.5252941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "71.0308824 39.7497059 55.8617647 26.2584118 55.3652941 49.9635294 77.1444118 48.9726471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "29.0391176 81.9767647 42.2211765 75.6123529 30.8732353 66.7705882"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "56.6644118 75.6123529 69.8082353 81.9767647 68.0126471 66.7705882"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#D5BFB2",
    fill: "#D5BFB2",
    points: "69.8082353 81.9767647 56.6641176 75.6123529 57.7341176 84.1491176 57.6194118 87.7697059"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#D5BFB2",
    fill: "#D5BFB2",
    points: "29.0388235 81.9767647 41.2658824 87.7697059 41.1894118 84.1491176 42.2211765 75.6123529"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#233447",
    fill: "#233447",
    points: "41.4952941 61.13 30.5673529 57.9288235 38.2858824 54.3844118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#233447",
    fill: "#233447",
    points: "57.39 61.13 60.5997059 54.3844118 68.3561765 57.9288235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#CC6228",
    fill: "#CC6228",
    points: "29.0391176 81.9767647 30.9494118 66.275 18.7989118 66.6182353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#CC6228",
    fill: "#CC6228",
    points: "67.9358824 66.275 69.8082353 81.9767647 80.0864706 66.6182353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#CC6228",
    fill: "#CC6228",
    points: "77.1444118 48.9726471 55.365 49.9635294 57.39 61.13 60.5997059 54.3844118 68.3561765 57.9288235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#CC6228",
    fill: "#CC6228",
    points: "30.5673529 57.9288235 38.2855882 54.3844118 41.4952941 61.13 43.5202941 49.9635294 21.7410294 48.9726471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#E27525",
    fill: "#E27525",
    points: "21.7411765 48.9726471 30.8732353 66.7705882 30.5676471 57.9288235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#E27525",
    fill: "#E27525",
    points: "68.3564706 57.9288235 68.0126471 66.7705882 77.1447059 48.9726471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#E27525",
    fill: "#E27525",
    points: "43.5205882 49.9635294 41.4952941 61.1302941 44.0552941 74.3164706 44.6285294 56.9379412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#E27525",
    fill: "#E27525",
    points: "55.3652941 49.9635294 54.2952941 56.9 54.8302941 74.3164706 57.3902941 61.1302941"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F5841F",
    fill: "#F5841F",
    points: "57.3902941 61.13 54.8302941 74.3164706 56.6644118 75.6123529 68.0126471 66.7705882 68.3564706 57.9288235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F5841F",
    fill: "#F5841F",
    points: "30.5673529 57.9288235 30.8732353 66.7705882 42.2211765 75.6123529 44.0552941 74.3164706 41.4952941 61.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#C0AC9D",
    fill: "#C0AC9D",
    points: "57.6194118 87.7697059 57.7341176 84.1491176 56.7405882 83.3105882 42.1447059 83.3105882 41.1894118 84.1491176 41.2658824 87.7697059 29.0388235 81.9767647 33.3185294 85.4829412 41.9917647 91.4664706 56.8552941 91.4664706 65.5670588 85.4829412 69.8082353 81.9767647"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#161616",
    fill: "#161616",
    points: "56.6644118 75.6123529 54.8302941 74.3164706 44.0552941 74.3164706 42.2211765 75.6123529 41.1894118 84.1491176 42.1447059 83.3105882 56.7405882 83.3105882 57.7341176 84.1491176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#763E1A",
    fill: "#763E1A",
    points: "95.6376471 30.4505882 98.8855882 14.6727353 93.9947059 -2.61228947e-15 56.6644118 27.6305882 71.0308824 39.7497059 91.32 45.6570588 95.7905882 40.4358824 93.8417647 39.0255882 96.9367647 36.2055882 94.5679412 34.3761765 97.6629412 32.0132353"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#763E1A",
    fill: "#763E1A",
    points: "0 14.6727353 3.286 30.4505882 1.1845 32.0132353 4.31764706 34.3761765 1.94867647 36.2055882 5.04361765 39.0255882 3.09494118 40.4358824 7.56544118 45.6570588 27.8547059 39.7497059 42.2211765 27.6305882 4.89079412 1.04491579e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F5841F",
    fill: "#F5841F",
    points: "91.3202941 45.6570588 71.0311765 39.7497059 77.1447059 48.9726471 68.0126471 66.7705882 80.0867647 66.6179412 98.1214706 66.6179412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F5841F",
    fill: "#F5841F",
    points: "27.8544118 39.7497059 7.56535294 45.6570588 0.802294118 66.6179412 18.7988529 66.6179412 30.8729412 66.7705882 21.7409706 48.9726471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#F5841F",
    fill: "#F5841F",
    points: "55.365 49.9635294 56.6641176 27.6305882 62.5485294 11.7382353 36.3370588 11.7382353 42.2211765 27.6305882 43.5202941 49.9635294 44.0170588 56.9758824 44.0552941 74.3164706 54.8302941 74.3164706 54.8685294 56.9758824"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.a32fd519.svg";
export { ForwardRef as ReactComponent };